import { ChevronDown } from 'lucide-react';
import { MathMarkdown } from '@/components/chat/MathMarkdown';

type ReasoningBlockProps = {
  reasoning: string;
  defaultOpen?: boolean;
};

export function ReasoningBlock({ reasoning, defaultOpen = false }: ReasoningBlockProps) {
  return (
    <details open={defaultOpen} className="bg-muted/30 rounded-lg px-3 py-2 text-xs text-muted-foreground">
      <summary className="cursor-pointer select-none flex items-center gap-1">
        <ChevronDown className="h-3.5 w-3.5" />
        Ragionamento
      </summary>
      <div className="mt-2 prose prose-sm max-w-none text-muted-foreground">
        <MathMarkdown>{reasoning}</MathMarkdown>
      </div>
    </details>
  );
}
